import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { SessionProvider } from '@/app/login/session';
import { router } from '@/app/routes';
import '@/styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root 없음 — index.html 확인');

createRoot(root).render(
  <StrictMode>
    <SessionProvider>
      <RouterProvider router={router} />
    </SessionProvider>
  </StrictMode>,
);
